<template>
  <collapse-default :id="`genitores-${ordem}`"
                    :collapse-visible="collapseVisible"
                    :condition="genitores.length > 0">
    <template v-slot:header>
      Genitores  {{ !genitores.length ? ' - Nenhum informado' : '' }}
    </template>

    <template v-slot:content>
      <div v-for="( genitor, index ) in genitores"
           :key="`genitor_${genitor.genitor_id}+${index}`"
           class="mt-3 resumo-show_header--shadow">
        <div class="resumo-show_header--blue ">
          {{ genitor.pessoa.nome || 'Não informado' }}
        </div>
        <div class="pl-4 pl-4 pb-3 row">
          <div class="col-9">
            <div class="row">
              <div v-if="genitor.pessoa.ocupacao_declarada != null"
                   class="col-3">
                <label class="resumo-show_header--label">Profissão</label>
                <div class="resumo-show_header--sublabel">
                  {{ genitor.pessoa.ocupacao_declarada || 'Não informado' }}
                </div>
              </div>
              <div class="col-3">
                <label class="resumo-show_header--label">Naturalidade</label>
                <div class="resumo-show_header--sublabel">
                  {{ genitor.pessoa.naturalidade || 'Não informado' }}
                </div>
              </div>
              <div class="col-5">
                <label class="resumo-show_header--label">Endereço cadastrado</label>
                <div class="resumo-show_header--sublabel">
                  {{ genitor.pessoa.endereco && (genitor.pessoa.endereco.logradouro || (genitor.pessoa.endereco.ibge && genitor.pessoa.endereco.cidade)) ? 'Sim' : 'Não' }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <BoxAvos v-if="propNascimento"
                 :prop-genitor="genitor" />
      </div>
    </template>
  </collapse-default>
</template>

<script>
  import CollapseDefault from "./CollapseDefault"
  import BoxAvos from '@/components/SofiaRei/Obito/BoxAvos.vue'

  export default {
    name: "GenitoresCollapse",
    components: {
      CollapseDefault,
      BoxAvos
    },
    props: {
      genitores: Array,
      collapseVisible: {
        type: Boolean,
        default: false
      },
      ordem: {
        type: Number,
        default: 1
      },
      propNascimento: { type: Boolean, default: false }
    },
  }
</script>

<style scoped>

</style>
